import React, { Component } from 'react';
import MobileAuthentication from './MobileAuthentication';
import ABHANumberVerification from './ABHANumberVerification';
import Aadhaarcollection from './Aadhaarcollection';
import AbhaAddressverfi from './AbhaAddressverfi';

import './Abha.css'; // Assuming CSS is shared
import { Button } from 'react-bootstrap';

export default class Downloads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'aadhar',
    };
  }

  handleTabChange = (tabName) => {
    this.setState({ activeTab: tabName });
  };

  renderTabContent = () => {
    const { activeTab } = this.state;

    switch (activeTab) {
      case 'aadhar':
        return (
        //   <div style={{ padding: '20px' }}>
        //     <h5>Download by Aadhaar Number</h5>
        //     {/* Your Aadhaar form or content here */}
        //     <p>Coming soon...</p>
        //   </div>
        <Aadhaarcollection/>
        );
      case 'mobile':
        return <MobileAuthentication />;
      case 'abha':
        return (
         <ABHANumberVerification/>
        );
        case 'abhaaddress':
                    return (
                     <AbhaAddressverfi/>
                    );
      default:
        return null;
    }
  };

  render() {
    const { activeTab } = this.state;

    return (
      <div style={{ padding: '20px' }}>
        <h4 className="mb-3">Download ABHA</h4>
        <div className="d-flex gap-2 mb-4">
            
          <Button
            variant={activeTab === 'aadhar' ? 'primary' : 'outline-primary'}
            onClick={() => this.handleTabChange('aadhar')}
          >
            Aadhaar Number
          </Button>
          <Button
            variant={activeTab === 'mobile' ? 'primary' : 'outline-primary'}
            onClick={() => this.handleTabChange('mobile')}
          >
            Mobile Number
          </Button>
          <Button
            variant={activeTab === 'abha' ? 'primary' : 'outline-primary'}
            onClick={() => this.handleTabChange('abha')}
          >
            ABHA Number
          </Button>
           <Button
                      variant={activeTab === 'abhaaddress' ? 'primary' : 'outline-primary'}
                      onClick={() => this.handleTabChange('abhaaddress')}
                    >
                      ABHA Address
                    </Button>
                    
        </div>

        <div className="tab-content-wrapper">{this.renderTabContent()}</div>
      </div>
    );
  }
}
